module.exports = __webpack_public_path__ + "img/no_user.c7b9cf67.jpg";